<template>
    <LoaderList v-if="isLoading" class="w-100" />
    <div class="d-flex flex-column flex-lg-row" v-else>
        <input type="hidden" name="staff_id" :value="actorId" />
        <div
            class="card rounded-lg p-3 w-100 staff-navbar"
        >
            <div class="card-body p-0">
                <staff-view-navbar
                    @refresh="getStaffDetail"
                ></staff-view-navbar>
            </div>
        </div>
        <div class="card rounded-lg p-3 w-100">
            <div class="card-body p-0">
                <staff-view-details v-if="staffProfileTab == 'profile'" />
                <staff-view-details-edit v-if="staffProfileTab == 'edit'" />
                <staff-view-timesheet v-if="staffProfileTab == 'time_sheet'" />
            </div>
        </div>
    </div>
</template>

<script>
import staffService from "@/services/staff";
import StaffViewNavbar from "@/components/setting-staff/staff-view-navbar.vue";
import StaffViewDetails from "@/components/setting-staff/staff-view-details.vue";
import StaffViewTimesheet from "@/components/setting-staff/staff-view-timesheet.vue";
import LoaderList from "@/components/elements/loader-list.vue";
import StaffViewDetailsEdit from "@/components/setting-staff/staff-view-details-edit.vue";

export default {
    name: "staffView",
    components: {
        StaffViewNavbar,
        StaffViewDetails,
        StaffViewTimesheet,
        StaffViewDetailsEdit,
        LoaderList
    },
    data() {
        return {
            isLoading: false,
            actorId: ""
        };
    },
    computed: {
        staffId() {
            return this.$route.params.id;
        },
        staffProfileTab() {
            return this.$store.getters["staff/staffProfileTab"];
        },
        refresh() {
            return this.$store.getters["staff/refresh"];
        }
    },
    watch: {
        refresh() {
            this.getStaffDetail();
        },
        staffId() {
            this.id = this.staffId;
            this.getStaffDetail();
        }
    },
    created() {
        this.id = this.staffId;
        this.getStaffDetail();
    },
    beforeDestroy() {
        this.$store.commit("staff/resetState");
    },
    methods: {
        async getStaffDetail() {
            this.isLoading = true;
            let data = await staffService.getStaffDetail(this.id);
            if (data.status == 200) {
                this.$store.commit(
                    "staff/setStaffDetails",
                    data.data.response.resource.actor
                );
                this.actorId = data.data.response.resource.actor.id;
            }
            this.isLoading = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@media (min-width: 992px) {
    .staff-navbar {
        max-width: 220px;
    }
}
</style>
